import moment from "moment";

// Function to calculate state
const generateRandomString = (length) => {
  const charset =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  for (let i = 0; i < length; i++) {
    result += charset.charAt(Math.floor(Math.random() * charset.length));
  }
  return result;
};

export const state = generateRandomString(10);
const sha256 = async (plain) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(plain);
  const hashBuffer = await crypto.subtle.digest("SHA-256", data);
  return hashBuffer;
};

const base64urlencode = (str) => {
  return btoa(String.fromCharCode.apply(null, new Uint8Array(str)))
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
};
export const codeVerifierData = generateRandomString(64); // Change the length as needed

export const generateCodeChallenge = async (codeVerifier) => {
  const hashed = await sha256(codeVerifier);
  return base64urlencode(hashed);
};

export const customDateFormat = (date, format = "YYYY-MM-DD") => {
  const options = {};

  if (format.includes("YYYY")) options.year = "numeric";
  if (format.includes("MM")) options.month = "2-digit";
  if (format.includes("DD")) options.day = "2-digit";
  if (format.includes("HH")) options.hour = "2-digit";
  if (format.includes("mm")) options.minute = "2-digit";
  if (format.includes("ss")) options.second = "2-digit";

  return new Intl.DateTimeFormat("en-US", options).format(new Date(date));
};

export const toCapitalize = (str) => {
  return str
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join("");
};
export const roleFormatter = (str) => {
  if (!str) return "-";
  return str
    ?.replace(/([a-z])([A-Z])/g, "$1 $2") // Adds space between lowercase and uppercase letters
    .replace(/^./, (str) => str.toUpperCase()) // Capitalizes the first letter of the string
    .split(/(?=[A-Z])/)
    .join(" ");
};

export function generateTimestampedFilename(propertyName, extension) {
  // Get the current UTC time
  const utcDate = new Date();

  // Convert UTC to IST (UTC + 5:30)
  const istDate = new Date(utcDate.getTime() + 5.5 * 60 * 60 * 1000);

  // Format the date to YYYY-MM-DD_HH-MM-SS format
  let timestamp = istDate
    .toISOString()
    .slice(0, 19)
    .replace(/:/g, "-")
    .replace("T", "_");

  // Return the formatted filename with the property name and timestamp
  return `${propertyName}_${timestamp}.${extension}`;
}

export const hourDateFormatter = (date) => {
  if (!date) return "";
  return moment(date).format("YYYY-MM-DDTHH:mm") || "";
};
export const getDateRange = (period) => {
  console.log(period, "see period")
  if (!period) return null; // Return null if no period selected

  const endDate = new Date();
  const startDate = new Date();

  switch (period) {
    case "7days":
      startDate.setDate(endDate.getDate() - 7);
      break;
    case "15days":
      startDate.setDate(endDate.getDate() - 15);
      break;
    case "1month":
      startDate.setMonth(endDate.getMonth() - 1);
      break;
    case "2months":
      startDate.setMonth(endDate.getMonth() - 2);
      break;
    case "6months":
      startDate.setMonth(endDate.getMonth() - 6);
      break;
    default:
      return null;
  }

  // Format dates as YYYY-MM-DD
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  return {
    startDate: formatDate(startDate),
    endDate: formatDate(endDate)
  };
};

const generatePasswordCustom = () => {
  const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const lower = "abcdefghijklmnopqrstuvwxyz";
  const numbers = "0123456789";
  const special = "@!#$%^&*()-_=+[]{}|;:,.<>?";

  const all = upper + lower + numbers + special;
  const getRandomChar = (set) =>
    set.charAt(Math.floor(Math.random() * set.length));

  let result = [
    getRandomChar(upper),
    getRandomChar(lower),
    getRandomChar(numbers),
    getRandomChar(special),
  ];

  for (let i = result.length; i < 12; i++) {
    result.push(getRandomChar(all));
  }

  result = result.sort(() => 0.5 - Math.random());

  return result.join("");
};


export default generatePasswordCustom;

export const getModuleDisplayName = (module) => {
  const moduleMap = {
    'leads': 'Leads',
    'contacts': 'Contacts',
    'accounts': 'Accounts',
    'deals': 'Deals',
    'tasks': 'Tasks',
    'meetings': 'Meetings',
    'calls': 'Calls'
  };
  return moduleMap[module?.toLowerCase()] || module;
};

 export const isToday = (someDate) => {
  const today = new Date();
  return (
    someDate.getDate() === today.getDate() &&
    someDate.getMonth() === today.getMonth() &&
    someDate.getFullYear() === today.getFullYear()
  );
};

